import {map as createMap, icon as createIcon, marker as createMarker, GeoJSON, circleMarker} from "@smartmaps/maps";
import {Geocoder} from "@smartmaps/geocoding";
import {Routing} from "@smartmaps/routing";
import markerIcon from '../images/marker.svg';

document.addEventListener("DOMContentLoaded", async function () {
    if (document.querySelector('.kampagne1')) {
        const mapElement = document.querySelector('#map');
        const mapFormElement = document.querySelector('.map-form');

        const state = {}

        const cards = document.querySelectorAll('.pi-info');

        const icon = createIcon({
            iconUrl: markerIcon,
            iconSize: [30, 49],
            iconAnchor: [15, 49]
        });

        const geocoder = new Geocoder('3%2BIrM%2Buvm2M5ynFYjCcLdp8qPrX7hyWiAnAExFzUh28%3D');

        const router = new Routing('3%2BIrM%2Buvm2M5ynFYjCcLdp8qPrX7hyWiAnAExFzUh28%3D');

        const map = await createMap('map', '3%2BIrM%2Buvm2M5ynFYjCcLdp8qPrX7hyWiAnAExFzUh28%3D');

        const openMapForm = function (card, marker) {
            state.targetMarker = marker;

            const address = card.querySelector('.card-text').innerHTML;

            mapFormElement.querySelector('.address').innerHTML = address;
            mapFormElement.querySelector('#hu-erinnerung').href = card.querySelector('.hu-link').href;
            mapFormElement.querySelector('#RouteEnd').value = address.split('<br>').slice(1, 3).map(line => line.trim()).join(', ');

            mapFormElement.classList.remove('hidden');
            mapFormElement.animate([{width: 0}, {width: '33%'}], {duration: 400, fill: 'both'});
            mapFormElement.animate([{opacity: 0}, {opacity: 1}], {delay: 400, duration: 200, fill: 'both'});
            mapElement.animate([{width: '100%'}, {width: '66%'}], {
                duration: 400,
                fill: 'both'
            });
            setTimeout(() => {
                map.invalidateSize(1);
                map.setView(marker.getLatLng(), 16);
            }, 400);
        }

        const closeMapForm = function () {
            clearMap();
            state.markers.forEach(marker => marker.addTo(map));
            mapFormElement.classList.add('hidden');
            mapFormElement.style.width = '0';
            mapElement.animate([{width: '66%'}, {width: '100%'}], {
                duration: 400,
                fill: 'both'
            });
            setTimeout(() => {
                map.invalidateSize(1);
                map.fitBounds(state.markers.map(marker => marker.getLatLng()));
            }, 400);
        }

        const createMarkerFromCard = function (card) {
            const lat = +card.dataset.lat;
            const lng = +card.dataset.lng;

            return createMarker({lat, lng}, {icon});
        }

        const clearMap = function () {
            state.markers.forEach(marker => marker.remove());
            if (state.activeUserMarker) {
                state.activeUserMarker.remove();
            }
            if (state.routingLayer) {
                state.routingLayer.remove();
            }
        }

        const startRouting = async function () {
            const result = await router.calcRoute([state.userMarker.getLatLng(), state.targetMarker.getLatLng()]);

            clearMap();

            state.activeUserMarker = state.userMarker

            state.routingLayer = new GeoJSON(result, {
                style: feature => {
                    if (feature.geometry.type === 'LineString') {
                        return {
                            weight: 7,
                            opacity: 0.8,
                            color: '#DA1F3D'
                        }
                    }
                },
                pointToLayer: (feature, latLng) => {
                    const marker = circleMarker(latLng);
                    marker.bindPopup(feature.properties.description);
                    return marker;
                }
            });

            state.userMarker.addTo(map);
            state.targetMarker.addTo(map);

            map.addLayer(state.routingLayer);

            map.fitBounds([state.userMarker.getLatLng(), state.targetMarker.getLatLng()]);
        }

        document.querySelector('#location').addEventListener('click', () => {
            navigator.geolocation?.getCurrentPosition(async position => {
                const latLng = {lat: position.coords.latitude, lng: position.coords.longitude};
                state.userMarker = createMarker(latLng, {icon});

                const result = await geocoder.geocodeReverse(latLng);
                const properties = result.features[0].properties;
                document.querySelector('#RouteStart').value = `${properties.street}${properties.houseNo ? ' ' + properties.houseNo : ''}, ${properties.zip} ${properties.city}`;
            })
        });

        document.querySelector('#RouteStart').addEventListener('change', async () => {
            const result = await geocoder.geocodeString(event.currentTarget.value);
            const coordinates = result.features[0].geometry.coordinates;
            state.userMarker = createMarker({lat: coordinates[1], lng: coordinates[0]}, {icon});
        });

        document.querySelector('#route-single-slot-form').addEventListener('submit', (event) => {
            event.preventDefault();
            if (!state.userMarker) return;

            startRouting();
        })

        document.querySelector('#reset-map').addEventListener('click', closeMapForm);

        state.markers = Array.from(cards).map(card => {
            const marker = createMarkerFromCard(card);

            marker.on('click', () => {
                openMapForm(card, marker);
            });
            card.querySelector('.location').addEventListener('click', () => {
                openMapForm(card, marker);
                mapElement.scrollIntoView();
            });

            marker.addTo(map);

            return marker;
        });

        map.fitBounds(state.markers.map(marker => marker.getLatLng()));
    }
});
